module.exports = __webpack_public_path__ + "static/media/thunderstorm.3fb783a8.svg";